/** @format */

import styled from "styled-components"

import { colors } from "../../../shared/styles/color"
import { TOAST_MAX_DURATION_MS } from "_stores/toast"

export const Container = styled.div({
	width: "100%",
})

type FillerProps = {
	kind: "success" | "error" | "warning"
	progression: number
}

export const Filler = styled.div<FillerProps>(({ kind, progression }) => ({
	width: `${progression}%`,
	height: 5,
	backgroundColor:
		kind === "success"
			? colors.C03
			: kind === "warning"
			? colors.C20
			: colors.C04,
	borderRadius: "0 0 8px 8px",
	transition: progression == 0 ? "" : `width ${TOAST_MAX_DURATION_MS}ms linear`,
}))
